/** Versioned sourcing wire contract. Keep the server twin identical. */
export type SourcingUnit = 'g' | 'ml' | 'piece';

export interface SourcingProductRef {
  key: string;
  platform: string;
  articleId: string;
  name: string;
  supplierName?: string;
}

export interface SourcingRunProduct extends SourcingProductRef {
  category: string;
  mainCategory: string;
  unit: SourcingUnit | null;
  /** Standard base units (g/ml/pieces) in one priced pack. */
  packAmount: number | null;
  /** Latest charged adjusted pack price, ex VAT. Null means unavailable. */
  price: number | null;
  /** Per kg/litre/individual piece, ex VAT. */
  unitPrice: number | null;
  unitPriceWithTaxes: number | null;
  orderDate: string | null;
  restaurantId: string | null;
  restaurantName: string | null;
  orderHistoryId: string | null;
}

export interface SourcingRunRequest {
  version: 2;
  products: SourcingProductRef[];
  targetRestaurantIds: string[];
  sourceFromRestaurantIds: string[];
}

export interface SourcingRunOption {
  productKey: string;
  matchScore: number;
}

export interface SourcingRunResponse {
  version: 2;
  generatedAt: string;
  windowStart: string;
  targetRestaurantIds: string[];
  sourceFromRestaurantIds: string[];
  originals: Record<string, SourcingRunProduct>;
  catalog: Record<string, SourcingRunProduct>;
  options: Record<string, SourcingRunOption[]>;
}

/** resolvedIdentifier comes from the platform's canonical identity helper. */
export function sourcingProductKey(platform: string, resolvedIdentifier: string, supplierName?: string): string {
  const supplier = platform.toLowerCase() === 'any_invoice' ? (supplierName ?? '').trim().toLowerCase() : '';
  return JSON.stringify([platform.toLowerCase(), supplier, resolvedIdentifier.trim().toLowerCase()]);
}
